import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_records_total_billed_by_current_month_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { date: string, owner_id?: number, project_id?: number, warehouse_ids?: number[], material_ids?: number[] }): 
  Promise<{ result: { total_amount?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.date)) {
      missingRequiredInParams.push('\'date\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_records_total_billed_by_current_month_widget/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      date: string, owner_id?: number, project_id?: number, warehouse_ids?: number[], material_ids?: number[]    }) {
        if(isNil(inParams.date)) {
          return true; 
        }
      return false;
    }
}
